import { Injectable } from '@angular/core';
import { QuantiteDossierByPeriodeDTO } from '../model/quantite-dossier-by-periode-dto';
import { ChartViewDTO } from '../model/chart_view/chart-view-dto';
import { QuantiteDossierByEmployeeDTO } from '../model/quantite-dossier-by-employee-dto';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class DashboardPpService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    QuantiteDossierByPeriode() 
    {
        return this._restClientService.load<QuantiteDossierByPeriodeDTO>('dashboard-pp/quantite-dossier-by-periode');
    }
    
    quantiteDossierStatutSurLes6DerniersMois() 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-pp/quantite-dossier-statut-sur-les-6-derniers-mois');
    }
    
    montantDossierStatutSurLes6DerniersMois() 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-pp/montant-dossier-statut-sur-les-6-derniers-mois');
    }
    
    slaProduitParPeriode()
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-pp/sla-produit-par-periode');
    }
    
    quantiteDossierByEmployee() 
    {
        return this._restClientService.load<QuantiteDossierByEmployeeDTO[]>('dashboard-pp/quantite-dossier-by-employee');
    }

    

}